module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAICAYAAADwdn+XAAAATklEQVQoU2O0yvhZz8DA0MBAHmhgBOkj05CGYzPYG8EGkGEIWDNIH9wAEgyBa8YwgAhDUDRjNQCPIRiacRqAxRCsmvEagGQIAyzAsMU0APPnJSNWjWVqAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/icon_arrow-blue.png
// module id = LIG8
// module chunks = 20